/*
 * MontiPower LATAM — Quote tool ("Cotización")
 * Self-contained, dependency-free. Stores a quote list in localStorage so it
 * never touches the real Shopify cart / checkout. Lets a customer collect
 * multiple products and send the list by email or WhatsApp.
 *
 * Configuration is injected by snippets/quote-config.liquid as window.MPQuoteConfig:
 *   { email, whatsapp, subject, labels:{...} }
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'mp_quote_items_v1';

  var CFG = window.MPQuoteConfig || {};
  // Fallback Spanish labels (overridden by config from theme settings)
  var L = Object.assign(
    {
      added: 'Añadido a la cotización',
      empty: 'Tu cotización está vacía.',
      remove: 'Quitar',
      qty: 'Cant.',
      title: 'Tu cotización',
      sku: 'SKU',
      sendEmail: 'Enviar por email',
      sendWhatsapp: 'Enviar por WhatsApp',
      clear: 'Vaciar',
      continue: 'Seguir explorando',
      itemsOne: 'producto',
      itemsMany: 'productos',
      greeting: 'Hola, me gustaría solicitar una cotización de los siguientes productos:',
      closing: 'Quedo a la espera de su respuesta. Gracias.'
    },
    CFG.labels || {}
  );

  /* ------------------------------------------------------------------ store */
  var Store = {
    items: [],
    load: function () {
      try {
        this.items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      } catch (e) {
        this.items = [];
      }
      if (!Array.isArray(this.items)) this.items = [];
      return this.items;
    },
    save: function () {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this.items));
      } catch (e) {}
      emit();
    },
    count: function () {
      return this.items.reduce(function (n, it) {
        return n + (parseInt(it.quantity, 10) || 1);
      }, 0);
    },
    find: function (key) {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].key === key) return i;
      }
      return -1;
    },
    add: function (item) {
      var i = this.find(item.key);
      if (i > -1) {
        this.items[i].quantity =
          (parseInt(this.items[i].quantity, 10) || 1) +
          (parseInt(item.quantity, 10) || 1);
      } else {
        item.quantity = parseInt(item.quantity, 10) || 1;
        this.items.push(item);
      }
      this.save();
    },
    setQty: function (key, qty) {
      var i = this.find(key);
      if (i > -1) {
        qty = parseInt(qty, 10) || 1;
        if (qty < 1) qty = 1;
        this.items[i].quantity = qty;
        this.save();
      }
    },
    remove: function (key) {
      var i = this.find(key);
      if (i > -1) {
        this.items.splice(i, 1);
        this.save();
      }
    },
    clear: function () {
      this.items = [];
      this.save();
    }
  };

  function emit() {
    document.dispatchEvent(
      new CustomEvent('quote:change', { detail: { items: Store.items, count: Store.count() } })
    );
  }

  // Analytics: push to GTM dataLayer and call gtag if present (GA4).
  function mpTrack(name, params) {
    params = params || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params));
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params);
    } catch (e) {}
  }
  window.MPQuoteTrack = mpTrack;

  /* -------------------------------------------------------------- messages */
  function lineFor(it) {
    var parts = [];
    parts.push('• ' + it.title);
    if (it.variant && it.variant !== 'Default Title') parts.push('(' + it.variant + ')');
    if (it.sku) parts.push('[' + L.sku + ': ' + it.sku + ']');
    parts.push('x ' + (it.quantity || 1));
    return parts.join(' ');
  }

  function absoluteUrl(u) {
    if (!u) return '';
    if (/^https?:\/\//i.test(u)) return u;
    return location.origin + u;
  }

  function buildPlainMessage() {
    var lines = [L.greeting, ''];
    Store.items.forEach(function (it) {
      lines.push(lineFor(it));
      if (it.url) lines.push('  ' + absoluteUrl(it.url));
    });
    lines.push('');
    lines.push(L.closing);
    return lines.join('\n');
  }

  function sendEmail() {
    if (!Store.items.length) return;
    var to = CFG.email || '';
    var subject = CFG.subject || 'Solicitud de cotización — MontiPower LATAM';
    var body = buildPlainMessage();
    mpTrack('quote_send_email', { quote_size: Store.count(), items: Store.items.length });
    var href =
      'mailto:' +
      encodeURIComponent(to) +
      '?subject=' +
      encodeURIComponent(subject) +
      '&body=' +
      encodeURIComponent(body);
    window.location.href = href;
  }

  function sendWhatsapp() {
    if (!Store.items.length) return;
    var num = (CFG.whatsapp || '').replace(/[^0-9]/g, '');
    var text = buildPlainMessage();
    mpTrack('quote_send_whatsapp', { quote_size: Store.count(), items: Store.items.length });
    var href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(text);
    window.open(href, '_blank');
  }

  // Compact product list for the hidden RFQ field (no greeting/closing).
  function buildItemsField() {
    return Store.items
      .map(function (it) {
        var s = lineFor(it);
        if (it.url) s += ' — ' + absoluteUrl(it.url);
        return s;
      })
      .join('\n');
  }

  // Fill any hidden RFQ product-list field just before the native form submits.
  function fillRfqFields() {
    var value = buildItemsField();
    document.querySelectorAll('[data-quote-items]').forEach(function (input) {
      input.value = value;
    });
  }

  /* ------------------------------------------------------- add-button glue */
  function readItemFromButton(btn) {
    // On a product page the variant/qty can change after render, so re-read
    // from the surrounding product form when present.
    var variantId = btn.getAttribute('data-variant-id') || '';
    var variant = btn.getAttribute('data-variant-title') || '';
    var qty = 1;
    var sku = btn.getAttribute('data-sku') || '';

    var scope =
      btn.closest('.product-form, product-form, .product__info-wrapper, .product, [data-quote-scope]') || document;
    var idInput = scope.querySelector
      ? scope.querySelector('form[data-type="add-to-cart-form"] [name="id"], product-form [name="id"]')
      : null;
    if (idInput && idInput.value) variantId = idInput.value;

    var qtyInput = scope.querySelector ? scope.querySelector('.quantity__input, input[name="quantity"]') : null;
    if (qtyInput && qtyInput.value) qty = parseInt(qtyInput.value, 10) || 1;

    return {
      key: String(variantId || btn.getAttribute('data-product-id') || btn.getAttribute('data-product-url')),
      productId: btn.getAttribute('data-product-id') || '',
      variantId: variantId,
      title: btn.getAttribute('data-product-title') || '',
      variant: variant,
      sku: sku,
      url: btn.getAttribute('data-product-url') || '',
      image: btn.getAttribute('data-product-image') || '',
      price: btn.getAttribute('data-product-price') || '',
      quantity: qty
    };
  }

  function flashButton(btn) {
    btn.classList.add('is-added');
    var labelEl = btn.querySelector('.quote-btn__label');
    var prev = labelEl ? labelEl.textContent : null;
    if (labelEl) labelEl.textContent = L.added;
    setTimeout(function () {
      btn.classList.remove('is-added');
      if (labelEl && prev !== null) labelEl.textContent = prev;
    }, 1600);
  }

  function onAddClick(e) {
    var btn = e.target.closest('[data-quote-add]');
    if (!btn) return;
    e.preventDefault();
    var item = readItemFromButton(btn);
    Store.add(item);
    mpTrack('add_to_quote', {
      item_name: item.title,
      item_id: item.sku || item.variantId || item.productId,
      quantity: item.quantity,
      quote_size: Store.count()
    });
    flashButton(btn);
    openDrawer();
  }

  /* ------------------------------------------------------------- drawer UI */
  function drawerEl() {
    return document.getElementById('QuoteDrawer');
  }

  function openDrawer() {
    var d = drawerEl();
    if (!d) return;
    renderAll();
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('quote-drawer-open');
  }

  function closeDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('quote-drawer-open');
  }

  function itemHtml(it) {
    var img = it.image
      ? '<img class="quote-item__img" src="' + escapeHtml(it.image) + '" alt="" loading="lazy">'
      : '<div class="quote-item__img quote-item__img--ph"></div>';
    var variant =
      it.variant && it.variant !== 'Default Title'
        ? '<span class="quote-item__variant">' + escapeHtml(it.variant) + '</span>'
        : '';
    var sku = it.sku ? '<span class="quote-item__sku">' + L.sku + ': ' + escapeHtml(it.sku) + '</span>' : '';
    var titleHtml = it.url
      ? '<a href="' + escapeHtml(it.url) + '" class="quote-item__title">' + escapeHtml(it.title) + '</a>'
      : '<span class="quote-item__title">' + escapeHtml(it.title) + '</span>';
    return (
      '<div class="quote-item" data-key="' + escapeHtml(it.key) + '">' +
      img +
      '<div class="quote-item__info">' +
      titleHtml +
      variant +
      sku +
      '<div class="quote-item__qtyrow">' +
      '<label class="quote-item__qtylabel">' + L.qty + '</label>' +
      '<input class="quote-item__qty" type="number" min="1" value="' + (it.quantity || 1) + '" data-key="' + escapeHtml(it.key) + '">' +
      '<button type="button" class="quote-item__remove" data-key="' + escapeHtml(it.key) + '">' + L.remove + '</button>' +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  // Renders every quote surface present in the DOM (drawer and/or page).
  function renderAll() {
    var hasItems = Store.items.length > 0;
    var listHtml = hasItems
      ? Store.items.map(itemHtml).join('')
      : '<p class="quote-empty">' + L.empty + '</p>';

    document.querySelectorAll('[data-quote-list]').forEach(function (list) {
      list.innerHTML = listHtml;
    });

    document.querySelectorAll('[data-quote-footer]').forEach(function (footer) {
      footer.style.display = hasItems ? '' : 'none';
    });

    var c = Store.count();
    var label = c + ' ' + (c === 1 ? L.itemsOne : L.itemsMany);
    document.querySelectorAll('[data-quote-count-label]').forEach(function (n) {
      n.textContent = label;
    });
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ----------------------------------------------------------- badge sync */
  function updateBadges() {
    var c = Store.count();
    var badges = document.querySelectorAll('[data-quote-count]');
    badges.forEach(function (b) {
      b.textContent = c;
      b.classList.toggle('is-empty', c === 0);
    });
  }

  /* ------------------------------------------------------------- bindings */
  function bind() {
    // Add to quote (delegated, works for dynamically loaded cards / quick view)
    document.addEventListener('click', onAddClick);

    // Open / close drawer + drawer actions (delegated)
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-quote-open]')) {
        e.preventDefault();
        openDrawer();
        return;
      }
      if (e.target.closest('[data-quote-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      var rm = e.target.closest('.quote-item__remove');
      if (rm) {
        Store.remove(rm.getAttribute('data-key'));
        return;
      }
      if (e.target.closest('[data-quote-send-email]')) {
        sendEmail();
        return;
      }
      if (e.target.closest('[data-quote-send-whatsapp]')) {
        sendWhatsapp();
        return;
      }
      if (e.target.closest('[data-quote-clear]')) {
        Store.clear();
        return;
      }
      var toggle = e.target.closest('[data-quote-rfq-toggle]');
      if (toggle) {
        var rfq = toggle.closest('[data-quote-rfq]');
        var panel = rfq && rfq.querySelector('[data-quote-rfq-panel]');
        if (panel) {
          var open = panel.hasAttribute('hidden');
          if (open) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        return;
      }
    });

    // Populate hidden product-list field right before a native RFQ form submits.
    document.addEventListener('submit', function (e) {
      if (e.target.closest('[data-quote-rfq-form]')) {
        fillRfqFields();
        var rfqForm = e.target.closest('[data-quote-rfq-form]');
        function rfqVal(n) {
          var el = rfqForm && rfqForm.querySelector('[name="contact[' + n + ']"]');
          return el ? el.value : '';
        }
        mpTrack('quote_request_submit', {
          quote_size: Store.count(),
          items: Store.items.length,
          project_type: rfqVal('tipo_de_proyecto'),
          industry: rfqVal('industria'),
          timeline: rfqVal('plazo')
        });
      } else if (e.target.closest('.askq-form')) {
        mpTrack('ask_question_submit', {});
      }
    });

    document.addEventListener('change', function (e) {
      var q = e.target.closest('.quote-item__qty');
      if (q) Store.setQty(q.getAttribute('data-key'), q.value);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    document.addEventListener('quote:change', function () {
      updateBadges();
      renderAll();
    });
  }

  // Expose a minimal API
  window.MPQuote = {
    open: openDrawer,
    close: closeDrawer,
    store: Store,
    sendEmail: sendEmail,
    sendWhatsapp: sendWhatsapp
  };

  function init() {
    Store.load();
    bind();
    updateBadges();
    renderAll();

    // After a successful RFQ send, Shopify reloads with the success message
    // rendered. Clear the saved quote and reveal the confirmation.
    if (document.querySelector('[data-quote-rfq-success]')) {
      Store.clear();
      var onPage = document.getElementById('QuotePage');
      if (!onPage) openDrawer();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
